<template>
    <splash v-show="isLoading" title="독해트레이닝 진단평가" />

    <div v-html="header" />
    <q-layout view="hHh lpR fFf" min-width="800px">
        <q-header reveal elevated class="bg-white text-black" height-hint="198">
            <q-toolbar elevated>
                <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center">
                    <div style="width: 200px">
                        <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="goToLogin" style="width: 2.4vw; height: 2.4vw; text-align: center; vertical-align: middle; cursor: pointer" />
                        <span class="text-h8 text-bold" style="vertical-align: middle">KReaD 진단평가 </span>
                    </div>

                    <div style="width: 200px; display: flex; margin: 0 auto; border-radius: 10px; align-items: center; justify-content: center">
                        <span>풀이 시간&nbsp;</span>
                        <span class="text-h5 text-bold" :class="isTimeOver ? 'color_red' : 'color_normal'" style="vertical-align: middle">{{ estimatedTime }} </span>
                    </div>
                    <div style="width: 200px"></div>
                </div>

                <!-- <q-space /> -->
            </q-toolbar>
            <q-linear-progress size="6px" :value="progressPercent" :class="progressClassColor" />
        </q-header>
        <q-page-container>
            <q-page>
                <div class="row">
                    <!------ 왼쪽페이지 -------------------------->
                    <div class="col myBox" style="padding: 30px">
                        <div v-html="contentsTitle" />
                        <div v-html="curPaper.exam.contents" />
                    </div>

                    <!-- 세로선 -------------------------------->
                    <!-- <div class="bg-grey-4" style="width: 0.5rem"></div> -->

                    <!--  오른쪽페이지 --------------------------->
                    <div class="col" style="padding: 30px">
                        <div v-html="unitText" />
                        <q-chip label="정답" color="blue" text-color="white" icon="warning" v-if="showTestLog">
                            &nbsp;&nbsp;&nbsp;
                            <h5 v-html="curUnit.answer" />
                        </q-chip>
                        <template v-for="(e, i) in curUnit.bogey" :key="i">
                            <q-btn no-caps flat v-html="e" :class="[{ mmSelected: curSel === i + 1 }, { transparent: curSel !== i + 1 }]" class="block text-left" @click="onBogey(i)" style="color: black" />
                        </template>
                        <div style="text-align: right" v-if="showBtnNext">
                            <q-btn unelevated rounded class="q-mt-xl q-pl-lg q-py-md" label="다음문제" icon-right="chevron_right" align="right" :disable="curSel == -1" @click="onNextUnit" />
                        </div>
                        <br />
                        <div style="text-align: center" v-if="showBtnResult">
                            <q-btn unelevated rounded class="q-mt-lg q-pl-lg q-py-md black" label="제출하기" icon-right="chevron_right" align="right" @click="onFinish" />
                        </div>
                        <!-- </q-scroll-area> -->
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>

    <modal-layer v-if="showResultPop" width="30rem">
        <div align="center" style="height: 400px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center">
            <img src="@/assets/images/logo.png" /><br /><br />
            <span style="color: #ef5724; font-weight: bold; font-size: 40px">
                {{ levelLessonStr }}
            </span>
            <br /><br />
            <q-btn size="lg" style="width: 200px" class="q-mt-sm text-h6" color="primary" @click="goToAppLogin" type="submit" label="로그인하기" />
        </div>
    </modal-layer>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';
import { GlobalStore } from '@/store';
import modalLayer from '@/components/layouts/layer/modalLayer';
import { scroll } from 'quasar';
import { useRouter } from 'vue-router';
import { useQuasar } from 'quasar';
import { postDiagnosticSubmit } from '@/api/modules/eval_api.js';

import splash from '@/components/template/splash.vue';

//////////////////----MyCode----///////////////////

import exam_total from './exam_total.json';
const router = useRouter();
const $q = useQuasar();
const showBtnNext = ref(false);
const showBtnResult = ref(false);
let showResultPop = ref(false);
let keywordKReadID = ref('KRT_E2_1450_N_06');

const globalStore = GlobalStore();
// let userName = globalStore.userInfo.id;
const minKread = 1200;
const maxKread = 1600;
const levelLessonStr = ref();

const { setVerticalScrollPosition, getScrollTarget } = scroll;
const scrollUpToTop = (id) => {
    const el = document.getElementById(id);
    const target = getScrollTarget(el);
    const offset = 0;
    const duration = 500;
    setVerticalScrollPosition(target, offset, duration);
};

//////////////////----시험지----///////////////////
const isLoading = ref(true);
const header = ref(exam_total[0].head);
const curPaper = ref({
    id: 'id',
    exam: {
        title: '<h3>loading</h3>',
        units: [],
    },
});
const createContentsNoStr = () => {
    const no = Number(unitNo.value);
    const aaaa = no % 3;
    const bbbb = aaaa == 1 ? `${no}-${no + 2}` : aaaa == 2 ? `${no - 1}-${no + 1}` : `${no - 2}-${no}`;

    return '※ [' + bbbb + '] ';
};
const contentsTitle = computed(() => {
    if (curPaper.value) {
        const tt = curPaper.value.exam.title.toString();
        const idx = tt.indexOf('다음');
        const second = tt.slice(idx);
        return createContentsNoStr() + second;
    }
    return '※';
});

const curUnit = ref({ text: '', answer: '', explanation: '', bogey: [''] });
const createNoStr = () => '' + unitNo.value + '.';
const unitText = computed(() => {
    if (curUnit.value.text) {
        const tt = curUnit.value.text.toString();
        const idx = tt.indexOf('(문');
        const first = tt.slice(0, idx);
        const second = tt.slice(idx + 4);
        return first + createNoStr() + second;
    }
    return '(문제)';
});

// watch(curUnit, (newcurUnit) => {
//     console.log('-watch-curUnit--', newcurUnit);
// });
// const startKRead = ref(globalStore.evalData.start_kread);
let mmmExams = [];
const unitNo = ref(0);
let nextNo = -1;

let curTopic = 0;
const setNextMMMexam = async () => {
    let nextMMM = 0;
    if (unitNo.value === 3) nextMMM = 1;
    if (unitNo.value === 6) nextMMM = 2;

    curPaper.value = await mmmExams[nextMMM];
    // curPaper.value = await mmmExams.shift();
    setCurUnit();
};

const setCurUnit = () => {
    unitNo.value++;
    // curUnit.value = curPaper.value.exam.units.shift(); // 다음문제 넣기
    nextNo = unitNo.value % 3 === 0 ? 2 : (unitNo.value % 3) - 1;
    curUnit.value = curPaper.value.exam.units[nextNo]; // 다음문제 넣기

    progressPercent.value = (unitNo.value * 100) / 36 / 100; // 진단평가 진행도 표시
    curSel.value = -1; // 초기화
    scrollUpToTop('right_contents');
    showBtnNext.value = true;
};
//////////////////----시험지로직----///////////////////
const Kdata = ref({
    grade: 'E1',
    kread: globalStore.evalData.first_kread,
    literature: 'L',
    topic: '00',
});
const createExamId = () => {
    const result = `KRT_${Kdata.value.grade}_${Kdata.value.kread}_${Kdata.value.literature}_${Kdata.value.topic}`;
    // console.log('--createExamId--', result);
    return result;
};

// 유저 답안지
const uPaper = ref([]);

const uKRead = ref(globalStore.evalData.start_kread); // 등급에 따른 시작크리드 점수, 유저 현재 크리드점수
let curSel = ref(-1); // 선택한 보기번호
const onBogey = (i) => {
    // showBtnNext.value = true;
    if (showBtnResult.value) return;
    curSel.value = i + 1;
    // console.log('--bogey', i + 1);
};

// 진단평가 결과
let idxLevLes = 0;
let arrRecommend = [];

// ttb
const testStrExamID = ref();
let testIsAllExam = false;
let ttestExamNo = -1;
let ttestUnitNo = -1;
const testSetTotalExamContents = () => {
    ttestUnitNo = -1;
    ++ttestExamNo;
    testStrExamID.value = exam_total[ttestExamNo].id + '   #### INDEX:' + ttestExamNo;

    curPaper.value = Object.assign(exam_total[ttestExamNo]);
    // console.log('--curPaper.value  --', curPaper.value);
    onNextUnit();
};
const onNextUnit = () => {
    if (testIsAllExam) {
        if (ttestUnitNo === 2) testSetTotalExamContents();
        else ++ttestUnitNo;
        curUnit.value = Object.assign(curPaper.value.exam.units[ttestUnitNo]);
        testStrExamID.value = testStrExamID.value + ' 문' + (ttestUnitNo + 1); // 현재 지문,문제번호 표기
        return;
    }

    showBtnNext.value = false;
    addUnitInOmr(); // omr에 기입
    // console.log('-onNextUnit-unitNo', unitNo.value);

    ////////// ---- M1 문제 분기 ---- //////////
    if (unitNo.value < 10) {
        if (unitNo.value === 3 || unitNo.value === 6) {
            setNextMMMexam(); // 다음 MMM시험지로
        } else if (unitNo.value === 9) {
            // 계산 & 다음 일반크리드로
            const kReadAmount = getKreadAmount2(); // 추가할 크리드점수
            setKdata(kReadAmount);

            setCurPaper(createExamId());
        } else {
            setCurUnit();
        }

        return;
    }

    ////////// ---- no M1  && isLastUnit? ---- //////////
    if (nextNo === 2) {
        const kReadAmount = getKreadAmount(); // 추가할 크리드점수
        setKdata(kReadAmount);
        //// 진단평가 마지막 문제인지 last
        if (uPaper.value.length === 36) {
            showBtnNext.value = false;
            showBtnResult.value = true;
            clearInterval(timeInterval);
            if (showTestLog.value) console.log(`--답안지--`, uPaper.value);
        } else {
            setCurPaper(createExamId());
        }
    } else {
        setCurUnit();
    }
};
const setKdata = (kReadAmount) => {
    uKRead.value = uKRead.value + kReadAmount;

    const resultKRead = Math.floor(uKRead.value / 50) * 50;
    const nextKRead = getMinMaxCheck(resultKRead); //  최소값 최대값 바운더리 체크
    const topic = '0' + ++curTopic;
    const literature = topic === '01' || topic === '02' ? 'L' : 'N';

    Kdata.value.grade = 'E2';
    Kdata.value.kread = nextKRead;
    Kdata.value.literature = literature;
    Kdata.value.topic = topic;

    if (showTestLog.value) console.warn(`--문제${unitNo.value}까지 결과-- 가감:${kReadAmount} 다음지문:`, nextKRead);
};
const setCurPaper = async (nextExamId) => {
    if (showTestLog.value) console.warn(`--호출하는 크리드ID--${nextExamId}`);

    // 시험지 뷰로 뿌리기
    const nextIdx = await exam_total.findIndex((item) => item.id === nextExamId);

    const nextPaper = exam_total[nextIdx];
    curPaper.value = Object.assign(nextPaper);
    // console.log('----setCurPaper---curPaper.value:', curPaper.value);

    setCurUnit();
};

const addUnitInOmr = () => {
    // appendId 붙이기
    let appendID = '';
    if (unitNo.value < 10) {
        if (unitNo.value < 4) appendID = '_01';
        else if (unitNo.value < 7) appendID = '_02';
        else if (unitNo.value < 10) appendID = '_03';
    }
    // omr에 추가.
    uPaper.value.push({
        exam_id: createExamId() + appendID,
        mm: curPaper.value.info.mm,
        kread: curPaper.value.info.kread,
        topic: curPaper.value.info.topic, //string
        num_user: curSel.value, // 찍은 보기
        num_correct: curUnit.value.answer, // 정답
        is_correct: curSel.value === curUnit.value.answer,
        weight: curUnit.value.weight,
        difficulty: curUnit.value.difficulty,
        cur_user_kread: uKRead.value,
    });
};
//////////////////----시간로직_프로그레스----///////////////////
let startTimeMillis, endTimeMillis;
const estimatedTime = ref('00:00');
let isTimeOver = false;

const progressPercent = ref(0.0);
const progressClassColor = ref('progressNormal');

const timeSec = ref(0);

watch(timeSec, (newTimeSec) => {
    if (newTimeSec >= 3600) isTimeOver = true;
    progressClassColor.value = isTimeOver ? 'progressWarn' : 'progressNormal';
});
let timeInterval;
const timeStr = (no) => no.toString().padStart(2, '0');
const startTimeCount = () => {
    timeInterval = setInterval(() => {
        ++timeSec.value;
        // const hour = Math.floor(time / 3600);
        const hour_ = timeSec.value % 3600;
        const min = Math.floor(timeSec.value / 60);
        const sec = hour_ % 60;
        estimatedTime.value = `${timeStr(min)}:${timeStr(sec)}`;
    }, 1000);
};

//////////////////----점수계산----///////////////////
/**
 * 문제 번호에 따라 ~ 가중치 + 난이도 => 추가할 크리드점수
 */
const getKreadAmount = () => {
    let cPoint = 0;
    cPoint = getPoints(unitNo.value - 3) + getPoints(unitNo.value - 2) + getPoints(unitNo.value - 1);
    if (showTestLog.value) console.log(`--가중치 계산 결과:`, cPoint);

    if (cPoint < 5) return -50;
    if (5 <= cPoint && cPoint < 6.5) return 0;
    if (6.5 <= cPoint) return 50;
};
// for M1
const getKreadAmount2 = () => {
    let cPoint = 0;

    for (let i in uPaper.value) {
        cPoint = cPoint + getPoints(i);
        // console.log('-plusKreadAmount-cPoint--:', cPoint);
    }
    if (showTestLog.value) console.log(`--가중치 계산 결과:`, cPoint);
    // plus Kread 점수 가져오기.
    if (cPoint < 6) return -100;
    if (6 <= cPoint && cPoint < 11) return -50;
    if (11 <= cPoint && cPoint < 17) return 0;
    if (17 <= cPoint && cPoint < 22) return 50;
    if (22 <= cPoint) return 100;
};
const getPoints = (unitNumber) => {
    const uPaper1 = uPaper.value[unitNumber];
    if (showTestLog.value) console.log(`--문제${Number(unitNumber) + 1} 크리드:${uPaper1.kread} 가중치:${uPaper1.weight} 난이도:${uPaper1.difficulty}  채점:`, uPaper1.is_correct ? 'O' : 'X');
    return uPaper1.is_correct ? uPaper1.weight + uPaper1.difficulty : 0;
};

//////////////////----최종 레벨레슨 계산----///////////////////
const onFinish = () => {
    showBtnResult.value = false;

    clearInterval(timeInterval);
    endTimeMillis = new Date().getTime();
    if (showTestLog.value) console.log('--평가종료 시간--:', endTimeMillis);

    const arrCorrect = uPaper.value.filter((item) => item.is_correct); // 맞은 문제 arr
    if (arrCorrect.length < 4) setLevLesStr(0); // 3문제 이하면 최하등급 확정.
    else {
        // 갈래별 분리, 정답있는 갈래만 add to arrResultKreads
        const chunk = getDivide(uPaper.value, 3);
        const arrResultKreads = []; // int only
        for (let i in chunk) {
            const topicArr = chunk[i];
            for (let j in topicArr) {
                if (topicArr[j].is_correct) {
                    addTopic(arrResultKreads, topicArr);
                    break;
                }
            }
        }

        // arr내의 평균값 구하기.
        let everage = arrResultKreads.reduce((before, current) => (before + current) / 2);
        uKRead.value = Math.round(everage); // 최종 유저크리드 점수 대입.

        if (showTestLog.value) console.log(`--유저점수 도출할 Kread지문들개수-${arrResultKreads.length}-:`, arrResultKreads);
        if (showTestLog.value) console.log('--위의 평균값--:', everage);
        // everage = Math.floor(everage);

        // 최소값 최대값 체크 : 최종크리드
        const finalKRead = getMinMaxCheck(everage);
        if (finalKRead === minKread) {
            setLevLesStr(0);
        } else {
            idxLevLes = getLevLesIndex(everage);
            // console.log('--setResultStr-idxLevLes:', idxLevLes);

            // 추천학습 해당되는 갈래 arr
            arrRecommend = getArrRecommendedLearning();
            let countRecommend = 0;
            arrRecommend.forEach((bool) => {
                if (bool) countRecommend++;
            });
            // console.log('--추천학습.length --', arrRecommend.length);
            // 추천학습 18개 이상이면 1단계 아래로.
            if (countRecommend >= 3) idxLevLes = getDownIdx(idxLevLes);

            setLevLesStr(idxLevLes);
        }
    }

    // 결과전송
    sendResultData();
};

// 진단평가 결과값 ttb
const sendResultData = async () => {
    const finalResult = {
        exprVersion: globalStore.version,
        score: uKRead.value,
        time: timeSec.value,
        level: levelObj[idxLevLes].level,
        lesson: levelObj[idxLevLes].lesson, 
        suggestion: [],
        result: getResultUpaper(),
    };

    if (showTestLog.value) console.log('--sendResultData-finalResult- :', finalResult);

    const res = await postDiagnosticSubmit(finalResult);
    if (showTestLog.value) console.warn('--sendResultData--전송결과 data:', res);
    if (res)
        if (res.statusCode === '200') showResultPop.value = true;
        else {
            showBtnResult.value = true;
            $q.dialog({
                message: res.message,
                persistent: true,
            });
        }
    else {
        showBtnResult.value = true;
        $q.dialog({
            message: `ERR_NETWORK_CHANGED:관리자에게 문의하세요.`,
            persistent: true,
        });
    }
};

// for resultData
const getResultUpaper = () => {
    const result = [];
    for (let i in uPaper.value) {
        const p = uPaper.value[i];
        result.push({
            examNm: p.exam_id,
            correct: p.num_correct,
            problemId: (Number(i) + 1).toString(),
            submitAnswer: p.num_user,
            isRight: p.is_correct,
        });
    }
    return result;
};

const setLevLesStr = (index) => {
    const levles = levelObj[index];
    // console.log('--setResultStr-index:', index);
    if (showTestLog.value) console.warn('--setResultStr-결과값 레벨레슨:', levles);
    levelLessonStr.value = `${levles.level}레벨 ${levles.lesson}레슨`;
};

const getDownIdx = (levObjIdx) => (levObjIdx === 0 ? 0 : levObjIdx - 1);

//추천학습에 해당하는 토픽리스트 11:현대시 12:고전시가 13:고전산문
const getArrRecommendedLearning = () => {
    const arrTopicsStr = [];
    if (uPaper.value.length !== 36) {
        console.error('--36문제 모두 입력되지 않았습니다.--', uPaper.value.length);
        $q.dialog({
            message: 'OMR error : 관리자에게 문의하세요.',
            persistent: true,
        });
        return arrTopicsStr;
    }
    arrTopicsStr.push(isNotPassRecommend(0, 6));
    arrTopicsStr.push(isNotPassRecommend(6, 9));
    arrTopicsStr.push(isNotPassRecommend(15, 6));
    arrTopicsStr.push(isNotPassRecommend(21, 6));
    arrTopicsStr.push(isNotPassRecommend(27, 6));
    arrTopicsStr.push(isNotPassRecommend(33, 3));

    if (showTestLog.value) console.log('--getArrRecommend--추천학습 해당사항:', arrTopicsStr);
    return arrTopicsStr;
};

// 추천학습에 통과하지 못한 토픽인지
const isNotPassRecommend = (start, size) => {
    // console.log('--@@size@@--', size);
    let count = 0;
    let resultForLog = [];
    for (let i = start; i < start + size; i++) {
        const p = uPaper.value[i];
        // console.log('--isNotPassRecommend p--', p, i);
        resultForLog.push(p.is_correct ? 'O' : 'X');
        if (p.is_correct) count++;
    }
    const percent = (count / size) * 100;
    if (showTestLog.value) console.log(`--문제수:${size}--맞춘확율:${percent}%--`, resultForLog);
    return percent < 51;
};

// 하나라도 맞춘 것, 토픽 전체문제 넣기 => arr
const addTopic = (bowl, arr) => {
    arr.forEach((e) => {
        bowl.push(e.kread);
    });
};

// chunk
const getDivide = (arr, size) => {
    const result = [];
    let i = 0;
    while (i < arr.length) {
        result.push(arr.slice(i, i + size));
        i += size;
    }
    return result;
};

const getMinMaxCheck = (digit) => {
    // min max check
    if (digit < minKread) return minKread;
    if (digit > maxKread) return maxKread;
    return digit;
};

const levelObj = [
    { level: 1, lesson: 1 },
    { level: 1, lesson: 1 },  
    { level: 2, lesson: 1 },
    { level: 2, lesson: 1 },  
    { level: 3, lesson: 1 },
    { level: 3, lesson: 1 },  
    { level: 3, lesson: 1 },  
];

const getLevLesIndex = (everage) => {
    // console.log('--getlevelstr everage--', everage);

    let index = 0;
    if (1200 <= everage && everage < 1350) index = 0;
    if (1350 <= everage && everage < 1400) index = 1;
    if (1400 <= everage && everage < 1450) index = 2;
    if (1450 <= everage && everage < 1500) index = 3;
    if (1500 <= everage && everage < 1550) index = 4;
    if (1550 <= everage && everage < 1600) index = 5;
    if (1600 <= everage) index = 6;
    return index;
};
//////////////////--------///////////////////

const goToAppLogin = () => {
    // showResultPop.value = false;
    // 초기화
    // globalStore.initUserData();
    router.push('/login');
};

const goToLogin = () => {
    // showTestLog.value = !showTestLog.value;
    $q.dialog({
        title: '평가 중단하기',
        message: '진단평가를 중단하고 이동하시겠습니까?',
        cancel: true,
        persistent: true,
    })
        .onOk(() => {
            router.push('/diagnostic-register');
        })
        .onCancel(() => {
            // console.log('--onCancel--:');
            // onOpenTest();
        });
};
const initData = async () => {
    // console.log('--init start--:');

    // tta 
    // testIsAllExam = true;
    // testSetTotalExamContents();전체불러오기
    // setCurPaper('KRT_E2_1250_N_07');KRT_E2_1350_N_07_01  KRT_E2_1350_N_07  KRT_E1_M2_L_00
    // isLoading.value = false;
    // setCurPaper('KRT_E1_M3_L_00');
    // return;
    ///////////////////////ttttest//////////////////

    startTimeMillis = new Date().getTime();
    if (showTestLog.value) console.log('--평가시작 시간--:', startTimeMillis);

    unitNo.value = 0;
    const examId = createExamId();
    const firstExam = await exam_total.filter((item) => item.id === examId);
    mmmExams = Object.assign(firstExam);
    if (showTestLog.value) console.log('--examId examId--:', examId);

    if (showTestLog.value) console.warn(`--initData-- 초기 크리드점수 :${uKRead.value} `);
    setNextMMMexam();
    setTimeout(() => {
        isLoading.value = false;
        startTimeCount();
    }, 1000);
};
onMounted(() => {
    initData();
});

// ttc
const showTestLog = ref(true);
const onOpenTest = () => {
    showTestLog.value = !showTestLog.value;
};
const showSearchedKread = ref(false);
const onTestKRead = () => {
    // console.log('---onTestKRead---');
    setCurPaper(keywordKReadID.value);
};
</script>

<style scoped lang="scss">
// .header-text {
//     font-weight: bold;
//     display: inline-flex;
//     margin-right: 20px;
// }
.color_red {
    color: #fd6956;
}
.color_normal {
    color: #8e8e8e;
}

.progressNormal {
    color: #8e8e8e;
}
.progressWarn {
    color: #fd6956;
}
button:disabled,
button[disabled] {
    // border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
}

button {
    background-color: #00a2e0;
    color: #fff;
}

.transparent {
    background-color: transparent;
}

.mmSelected {
    background-color: #cbcbcb;
}
.black {
    background-color: #000;
}
::v-deep {
    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}
</style>
